/** The material state of one pass of a surface, in three's terms. */
import { opaquePrepassUserData } from './opaquePrepass';
import { alphaHashScaleUserData } from './godotAlphaHash';
import { alphaAntialiasingProps, alphaAntialiasingUserData } from './godotAlphaAntialiasing';
/**
 * The material props of one pass: its blend state, and the `userData` the hash, antialiasing and
 * prepass patches read. Every mode's material carries the scale and the edge (`sprite_3d.cpp:281-283`):
 * only HASH reads the scale, and only an antialiased cut the edge.
 */
export function passBlendMaterialProps(blend) {
    return {
        transparent: blend.transparent,
        depthWrite: blend.depthWrite,
        alphaTest: blend.alphaTest,
        alphaHash: blend.alphaHash,
        blending: blend.blending,
        ...alphaAntialiasingProps(blend.antialiasing),
        userData: {
            ...alphaHashScaleUserData(blend.alphaHashScale),
            ...alphaAntialiasingUserData(blend.antialiasing),
            ...opaquePrepassUserData(blend.opaquePrepass),
        },
    };
}
//# sourceMappingURL=surfaceBlend.js.map